import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Spinner, Alert, Pagination, Badge, Form, Card } from 'react-bootstrap';
import * as adminApi from '../../Services/adminApi';
import { Link } from 'react-router-dom';

const ReportedListings = () => {
    // ... (ostala stanja ostanejo enaka)
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filter, setFilter] = useState('false'); // Default to show pending reports

    const fetchReports = useCallback(async () => {
        setLoading(true);
        try {
            const params = { page: currentPage, limit: 5, resolved: filter };
            const data = await adminApi.getReportedListings(params);
            setReports(data.reports);
            setTotalPages(data.totalPages);
            setError('');
        } catch (err) {
            setError('Failed to fetch reported listings.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [currentPage, filter]);

    useEffect(() => {
        fetchReports();
    }, [fetchReports]);

    const handleResolveReport = async (reportId) => {
        if (window.confirm('Are you sure you want to mark this report as resolved?')) {
            try {
                await adminApi.resolveReport(reportId);
                fetchReports(); // Refresh list
            } catch (err) {
                alert('Failed to resolve report.');
            }
        }
    };

    const handleDeleteListing = async (listingId, title) => {
        // Dodatno preverjanje za primer, če listingId ni posredovan
        if (!listingId) {
            alert('Cannot delete listing: Listing ID is missing.');
            return;
        }
        if (window.confirm(`This will also resolve the report. Are you sure you want to delete the listing "${title}"?`)) {
            try {
                await adminApi.deleteListing(listingId);
                fetchReports(); // Refresh list
            } catch (err) {
                alert('Failed to delete listing.');
            }
        }
    };

    return (
        <div>
            <h2>Reported Listings</h2>
            <hr />

            <Form.Group className="mb-3" style={{ maxWidth: '200px' }}>
                <Form.Label>Filter by Status</Form.Label>
                <Form.Select value={filter} onChange={(e) => { setFilter(e.target.value); setCurrentPage(1); }}>
                    <option value="false">Pending</option>
                    <option value="true">Resolved</option>
                    <option value="">All</option>
                </Form.Select>
            </Form.Group>

            {loading && <div className="text-center"><Spinner animation="border" /></div>}
            {error && <Alert variant="danger">{error}</Alert>}

            {!loading && !error && (
                <>
                    {reports.map(report => (
                        <Card key={report.id} className="mb-3">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <strong>Report #{report.id}</strong>
                                {report.is_resolved
                                    ? <Badge bg="success">Resolved</Badge>
                                    : <Badge bg="warning" text="dark">Pending</Badge>}
                            </Card.Header>
                            <Card.Body>
                                {/* SPREMEMBA: Preverjamo, ali 'reported_listing' sploh obstaja.
                                    To prepreči napake, če je bil oglas vmes že izbrisan. */}
                                {report.reported_listing ? (
                                    <div className="d-flex">
                                        {/* SPREMEMBA: Uporabljamo 'reported_listing' */}
                                        <img src={report.reported_listing.images?.find(img => img.is_primary)?.image_url || 'https://via.placeholder.com/150'} alt="listing" style={{ width: '100px', height: '100px', objectFit: 'cover', marginRight: '15px' }} />
                                        <div>
                                            {/* SPREMEMBA: Uporabljamo 'reported_listing' */}
                                            <h5><Link to={`/oglas/${report.reported_listing?.slug}/${report.reported_listing?.id}`}>{report.reported_listing?.title}</Link></h5>
                                            <p className="mb-1"><strong>Reason for report:</strong> {report.reason}</p>
                                            <p className="text-muted mb-1">
                                                Reported by: {report.reporter?.username || 'N/A'} on {new Date(report.created_at).toLocaleString()}
                                            </p>
                                            <p className="text-muted mb-0">
                                                {/* SPREMEMBA: Uporabljamo 'reported_listing' */}
                                                Listing owner: {report.reported_listing.seller?.username || 'N/A'}
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <p><strong>Reason for report:</strong> {report.reason}</p>
                                        <Alert variant="secondary">The associated listing has been deleted.</Alert>
                                    </div>
                                )}
                            </Card.Body>
                            <Card.Footer className="text-end">
                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => handleResolveReport(report.id)}
                                    disabled={report.is_resolved}
                                >
                                    <i className="fas fa-check-circle me-1"></i> Resolve
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    // SPREMEMBA: Posredujemo 'id' in 'title' iz 'reported_listing'
                                    // in onemogočimo gumb, če oglas ne obstaja.
                                    onClick={() => handleDeleteListing(report.reported_listing?.id, report.reported_listing?.title)}
                                    disabled={!report.reported_listing}
                                >
                                    <i className="fas fa-trash me-1"></i> Delete Listing
                                </Button>
                            </Card.Footer>
                        </Card>
                    ))}
                    {totalPages > 1 && (
                        <Pagination className="justify-content-center">
                            <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                            <Pagination.Item active>{currentPage} of {totalPages}</Pagination.Item>
                            <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                        </Pagination>
                    )}
                </>
            )}
        </div>
    );
};

export default ReportedListings;